var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0C0.651754 0 0.558494 0.0206375 0.472656 0.0546875L4.71484 3.76173C4.89822 3.92193 5.09354 3.92204 5.27734 3.76173L9.52734 0.0546875C9.44151 0.0206375 9.34825 0 9.25 0H0.75ZM0.0078125 0.644524C0.00308375 0.678699 0 0.714487 0 0.75V5.75C0 6.16549 0.334507 6.5 0.75 6.5H9.25C9.66549 6.5 10 6.16549 10 5.75V0.75C10 0.714487 9.99691 0.678699 9.99219 0.644524L5.76953 4.32812C5.32897 4.71239 4.66319 4.713 4.22266 4.32812L0.0078125 0.644524Z",
    fill: "#DB9600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.fd788aea919355c9522ce93101846a8a.svg";
export { ForwardRef as ReactComponent };